import React from "react";
import { useNavigate } from "react-router-dom";

import { SessionStorage } from "../../util";
import { Common, CommonPages, ERROR, SessionStorageKeys } from "../../helper";
import { clearStore } from "../..";

import "../../assets/stlyes/Common/PageNotFound.scss";

const PageNotFound = ({ sessionExpired }) => {
  const navigate = useNavigate();
  let token = SessionStorage.getItem(SessionStorageKeys.SessionToken);

  const checkStorage = () => {
    if (sessionExpired) {
      navigate(CommonPages.login);
      window.location.reload();
      clearStore();
      SessionStorage.clearAll();
    } else {
      token ? navigate(CommonPages.dashboard) : navigate(CommonPages.login);
    }
  };

  return (
    <div className={`main-page-not-found ${sessionExpired && "session-expired"}`}>
      <p className="text">{sessionExpired ? ERROR.ACCESS_DENIED : ERROR.PAGE_NOT_FOUND}</p>
      <button className="button" onClick={() => checkStorage()}>
        {sessionExpired ? Common.BackToLogin : token ? Common.BackToDashboard : Common.BackToLogin}
      </button>
    </div>
  );
};

export { PageNotFound };
